import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import PerfilesView from './PerfilesView';
import * as ROUTES from '../../../router/Routes';

const PerfilesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.perfiles} routes={[]}>
      <PerfilesView />
    </ContainerTemplate>
  );
};

export default PerfilesModule;
